import { useMemo } from "react";
import { CompanyAttribute } from "app/api/graph/security-attributes";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { useCompanyQuery } from "app/api/graph/types";

type Result = GeneralResult & {
    canListUserInvites: boolean;
    canCreateUserInvite: boolean;
    canListUsers: boolean;
    canAddUser: boolean;
    canRemoveUser: boolean;
    canCreateReport: boolean;
};

export const useCompanyPermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canListUserInvites: permissions?.includes(CompanyAttribute.ViewUserInvites) ?? false,
            canCreateUserInvite: permissions?.includes(CompanyAttribute.InviteUser) ?? false,
            canListUsers: permissions?.includes(CompanyAttribute.ViewUsers) ?? false,
            canAddUser: permissions?.includes(CompanyAttribute.AddUser) ?? false,
            canRemoveUser: permissions?.includes(CompanyAttribute.RemoveUser) ?? false,
            canCreateReport: permissions?.includes(CompanyAttribute.CreateReport) ?? false,
        }),
        [permissions],
    );
};

export const useCompanyIdPermissions = (companyId: string): Result => {
    const { data } = useCompanyQuery({
        variables: { companyId: companyId },
    });

    return useCompanyPermissions(data?.company?.permissions);
};
